import { NgFor, NgIf } from '@angular/common';
import { ChangeDetectorRef, Component, inject, Input, OnDestroy, OnInit } from '@angular/core';
import { FormGroup, FormsModule, UntypedFormBuilder, UntypedFormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatProgressSpinnerModule, MatSpinner } from '@angular/material/progress-spinner';
import { FuseCardComponent } from '@fuse/components/card';
import { SharedMethodsModule } from 'app/core/shared-services/shared-methods.module';
import { SharedServiceService } from 'app/core/shared-services/shared-service.service';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatSelectModule } from '@angular/material/select';


@Component({
  standalone: true,
  selector: 'app-cancel-order',
  templateUrl: './cancel-order.component.html',
  styleUrls: ['./cancel-order.component.scss'],
  imports: [NgFor, MatSelectModule, MatDialogModule, FuseCardComponent, MatProgressSpinnerModule, MatButtonModule, NgIf, NgFor, FormsModule, MatFormFieldModule, MatInputModule, ReactiveFormsModule, MatDatepickerModule]
})

export class CancelOrderComponent implements OnInit {
  // ## VARS ##
  public cancelled: boolean = false;
  public cancellationReasonsList: any;
  public cancellationForm: UntypedFormGroup;
  public datePicker: UntypedFormGroup;
  public reason: UntypedFormGroup;
  public comment: UntypedFormGroup;
  public loading: boolean;
  public cancelLoading: boolean;
  public matSelectedValue: string;
  public requiresAdditionalInformation: boolean = false;


  // ## DEPENDENCIES #
  private _sharedMethods = inject(SharedMethodsModule);
  private dialogRef = inject(MatDialogRef<CancelOrderComponent>);
  private formBuilder = inject(UntypedFormBuilder);
  private _sharedService = inject(SharedServiceService);
  private data: { debitOrder: any } = inject(MAT_DIALOG_DATA);

  // ## HOOKS ##
  ngOnInit() {
    this.cancellationForm = this.formBuilder.group({
      reason: [this.reason, Validators.required],
      suggestedImprovements: [],
      additionalInformation: [],
    });
    this.getCancelationReasonOData();
  }

 
  // ## METHODS ##
  public closeDialog() {
    this.dialogRef.close();
  }

  public cancelOrder() {
      const cancellationReason = this.cancellationForm.value.reason;
      const suggestedImprovments= this.cancellationForm.value.suggestedImprovements; 
      const additionalInformation= this.cancellationForm.value.additionalInformation; 
      let leadNotes = '';

      if (suggestedImprovments) {
        leadNotes = 'Suggested Improvements: ' + suggestedImprovments
      }
      if (additionalInformation ) {
        leadNotes = leadNotes + '\n' +  'Additional Information: ' + additionalInformation
      }
      
      this._sharedMethods.CancelOrder(this.data?.debitOrder?.LeadEntityID, cancellationReason, leadNotes).then((res) => {
        this.cancelled = true;
        this.reloadDebitOrders();
      });
 
  }

  public reasonChange(val: any) {

    if (val.value.RequiresAdditionalInformation) {
      this.requiresAdditionalInformation = true;

      this.cancellationForm.get('additionalInformation').setValidators([Validators.required]);
      this.cancellationForm.get('additionalInformation').updateValueAndValidity();
    } else {
      this.requiresAdditionalInformation = false
    }
  }

  private getCancelationReasonOData() {
    this._sharedMethods.getCancelationReasonOData().then((res) => {
      this.cancellationReasonsList = res?.result;
    }).finally(() => {
      this.loading = false;
    });
  }

  private reloadDebitOrders() {
    this._sharedMethods.getDebitOrderMandatesDetails(this._sharedService.debitOrdersArray);
  }



}


